import { useRef } from 'react'
import { Link } from 'react-router'
import styled from '@emotion/styled'
import TextTooltip from 'src/ui-kit/textTooltip/TextTooltip'
import { useHover } from 'src/components/app/utils/hooks/useHover'
import { shortenEmail } from 'src/components/parts/history/hunter/user-email-link/userEmailLinkUtils'

interface UserEmailLinkProps {
    email: string
    href: string
    operatorType: 'hunter' | 'user'
}

export function UserEmailLink({ email, href, operatorType }: UserEmailLinkProps) {
    const operatorLabel = operatorType === 'hunter' ? 'HUNTER:' : 'USER:'
    const hoverRef = useRef<HTMLSpanElement>(null)
    const isHovering = useHover(hoverRef)

    return (
        <UserEmailLinkContainer>
            <span ref={hoverRef}>
                <Link to={href}>{shortenEmail(email)}</Link>
            </span>
            {isHovering && (
                <TextTooltip top='-58px' left='-9px'>
                    {operatorLabel}
                    <br />
                    {email}
                </TextTooltip>
            )}
        </UserEmailLinkContainer>
    )
}

const UserEmailLinkContainer = styled.div`
    position: relative;
`
